export const VEHICLE_LISTING_REQUEST = '@OXD/VEHICLE_LISTING_REQUEST'
export const VEHICLE_LISTING_SUCCESS = '@OXD/VEHICLE_LISTING_SUCCESS'
export const VEHICLE_LISTING_FAILURE = '@OXD/VEHICLE_LISTING_FAILURE'

export const VEHICLE_SEARCH_REQUEST = '@OXD/VEHICLE_SEARCH_REQUEST'
export const VEHICLE_SEARCH_SUCCESS = '@OXD/VEHICLE_SEARCH_SUCCESS'
export const VEHICLE_SEARCH_FAILURE = '@OXD/VEHICLE_SEARCH_FAILURE'

export const VEHICLE_SUMMARY_REQUEST = '@OXD/VEHICLE_SUMMARY_REQUEST'
export const VEHICLE_SUMMARY_SUCCESS = '@OXD/VEHICLE_SUMMARY_SUCCESS'
export const VEHICLE_SUMMARY_FAILURE = '@OXD/VEHICLE_SUMMARY_FAILURE'

export const VEHICLE_FORM_UPDATE = '@OXD/VEHICLE_FORM_UPDATE'

export const VEHICLE_SUMMARY_ALL_REQUEST = '@OXD/VEHICLE_SUMMARY_ALL_REQUEST'
export const VEHICLE_SUMMARY_ALL_SUCCESS = '@OXD/VEHICLE_SUMMARY_ALL_SUCCESS'
export const VEHICLE_SUMMARY_ALL_FAILURE = '@OXD/VEHICLE_SUMMARY_ALL_FAILURE'

export const VEHICLE_FILTERS_REQUEST = '@OXD/VEHICLE_FILTERS_REQUEST'
export const VEHICLE_FILTERS_SUCCESS = '@OXD/VEHICLE_FILTERS_SUCCESS'
export const VEHICLE_FILTERS_FAILURE = '@OXD/VEHICLE_FILTERS_FAILURE'
